
<template>
    <!-- Branches.vue -->
    <div>
        <HeaderBg :title="$t('adminLogActions.title')" />

        <RequestSpinner v-if="loadingRequest == true" />

        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th>{{$t('adminLogActions.event')}}</th>
                        <th>{{$t('adminLogActions.name')}}</th>
                        <th>{{$t('adminLogActions.permission')}}</th>
                        <th>{{$t('adminLogActions.eventType')}}</th>
                        <th>{{$t('adminLogActions.date')}}</th>
                        <th>{{$t('adminLogActions.user')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="logAction in logActions" :key="logAction.id">
                        <td>{{ logAction.action }}</td>
                        <td>{{ logAction.user.name }}</td>
                        <td>{{ logAction.user.role }}</td>
                        <td>{{ logAction.action_mode }}</td>
                        <td>{{ logAction.created_at }}</td>
                        <td>{{ logAction.user.name }}</td>
                    
                    </tr>
                </tbody>
            </table>
        </div>
         <div class="pagination mt-5" v-if="logActions.length >= 1 && loadingRequest == false">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
export default {
    name:'LogActions',
    components: {HeaderBg, RequestSpinner},
    data(){
        return{
            loadingRequest: true,
            logActions: [],

               // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        this.getactionLogs();
    },
    methods:{
        getactionLogs(){
            Request.fetch('admin/log_actions', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.loadingRequest = false;
                this.logActions = response.data.data
                this.pages = Math.ceil(response.data.meta.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getactionLogs();
            } else{
                this.apiParams = `?page=${val}`;
                this.getactionLogs();
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>